import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./PurchasePrint.css";
import api from "../services/api";

const WorkerLedgerPrint = () => {
  const [invoiceData, setInvoiceData] = useState(null);
  const { search, from, to } = useParams();

  useEffect(() => {
    fetchPurchases();
  }, []);

  useEffect(() => {
    if (invoiceData) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [invoiceData]);
  const formatDDMMYYYY = (date) => {
    const d = String(date.getDate()).padStart(2, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${d}-${m}-${y}`;
  };

  const getMonthStartEnd = () => {
    const now = new Date();

    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    return {
      from_date: formatDDMMYYYY(start),
      to_date: formatDDMMYYYY(end),
    };
  };

  const fetchPurchases = async () => {
    try {
      const { from_date, to_date } = getMonthStartEnd();

      const response = await api.post("/worker_ledger_print.php",
        {
          search: search,

          from_date: from ?? from_date,
          to_date: to ?? to_date,
        });

      if (response.data.head.code === 200) {

        setInvoiceData(response.data.body);
      } else if (response.data.head.code === 606) {
        // No purchases found - set empty array
        setInvoiceData([]);
      } else {
      }
    } catch (err) {
      console.error("Error fetching purchases:", err);
    } finally {
    }
  };

  // useEffect(() => {
  //     const found = dummyInvoices.find(i => i.id === parseInt(id));
  //     if (found) setInvoiceData(found);
  //     setTimeout(() => window.print(), 800);
  // }, [id]);

  if (!invoiceData) return null;

  const totals = invoiceData?.items?.reduce(
    (acc, item) => {
      acc.totalDebit += Number(item.debit || 0);
      acc.totalCredit += Number(item.credit || 0);
      return acc;
    },
    { totalDebit: 0, totalCredit: 0 }
  );

  const netBalance = (totals?.totalDebit || 0) - (totals?.totalCredit || 0);


  return (
    <div className="print-page">

      <div className="page-border"></div>

      <div className="print-content">

        {/* HEADER */}
        <div
          className="header-section"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <div style={{ width: "33%" }}></div>

          <div
            className="title"
            style={{
              width: "33%",
              textAlign: "center",
              fontWeight: "normal",
            }}
          >
            Job Work Ledger
          </div>

          <div
            style={{
              width: "33%",
              textAlign: "right"
            }}
          >
            CELL : {invoiceData.seller_detail.mobile}
          </div>
        </div>

        {/* COMPANY */}
        <div className="company-section" style={{ marginTop: "10px" }}>
          <div className="company-details">
            <h1>{invoiceData.seller_detail.shop_name}</h1>
            <div style={{ fontSize: "16px" }}>{invoiceData.seller_detail.address},
              {invoiceData.seller_detail.city},{" "}
              {invoiceData.seller_detail.state} -{" "}
              {invoiceData.seller_detail.pincode}
            </div>
            <div style={{ fontSize: "16px" }}><b>GSTIN :</b> {invoiceData.seller_detail.gst}</div>
          </div>
        </div>

        {/* CUSTOMER + DATE INFO */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
            fontSize: "14px",
            borderTop: "1px solid black",
            borderBottom: "1px solid black",
            padding: "6px 4px"
          }}
        >
          <div>
            <b>Job Worker Name :</b> {invoiceData.items[0]?.worker_name}
          </div>

          <div>
            {/* <b>Date :</b> {invoiceData.items[0]?.date} */}
            <div>
              <b>Period :</b> {from ?? getMonthStartEnd().from_date} to {to ?? getMonthStartEnd().to_date}
            </div>

          </div>
        </div>


        <div style={{ display: "flex", flexDirection: "column", minHeight: "48vh" }}>
          {/* ITEMS TABLE */}
          <table className="items-table" style={{ marginTop: "10px" }}>
            <colgroup>
              <col style={{ width: "6%" }} />   {/* S.No */}
              <col style={{ width: "13%" }} />  {/* Date */}
              <col style={{ width: "15%" }} />  {/* Description */}
              <col style={{ width: "14%" }} />  {/* Payment Type */}
              <col style={{ width: "14%" }} />  {/* Reference */}
              <col style={{ width: "12%" }} />  {/* Debit */}
              <col style={{ width: "12%" }} />  {/* Credit */}
              <col style={{ width: "14%" }} />  {/* Balance */}
            </colgroup>


            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th className="text-center">Description</th>
                <th>Payment Type</th>
                <th className="text-center">Reference No</th>

                <th className="text-end">Debit</th>

                <th className="text-end">Credit</th>
                <th className="text-end">Balance</th>

              </tr>
            </thead>
            <tbody>
              {invoiceData.items.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.description || "-"}</td>
                  <td>{item.payment_type || "-"}</td>
                  <td>{item.reference_no || "-"}</td>

                  <td className="text-end">₹ {Number(item.debit).toFixed(2)}</td>
                  <td className="text-end">₹ {Number(item.credit).toFixed(2)}</td>
                  <td className="text-end">₹ {Number(item.balance).toFixed(2)}</td>
                </tr>
              ))}

              {/* TOTAL ROW */}
              <tr className="fw-bold" style={{ borderTop: "2px solid black" }}>
                <td colSpan="5" className="text-end">TOTAL</td>
                <td className="text-end">₹ {totals.totalDebit.toFixed(2)}</td>
                <td className="text-end">₹ {totals.totalCredit.toFixed(2)}</td>
                <td className="text-end">
                  ₹ {Math.abs(netBalance).toFixed(2)} {netBalance >= 0 ? " Dr" : " Cr"}
                </td>
              </tr>
            </tbody>

          </table>
        </div>






      </div>
    </div>
  );
};

export default WorkerLedgerPrint;
